import { useQuery } from "@apollo/client/react";
import Form from "components/controls/Form";
import FormButtons from "components/controls/FormButtons";
import StickyFooter from "components/controls/StickyFooter";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import LayoutSetting from "components/pages/site/LayoutSetting";
import paths from "config/routePaths";
import { GetLayoutSetting } from "hooks/apollo/customerSettings/customerSettings.gql";
import useUpdateCustomerSettings from "hooks/apollo/customerSettings/useUpdateCutomerSettings";
import useGoBack from "hooks/useGoBack";
import React from "react";

export default function CustomerSettings() {
  const { goBack } = useGoBack();

  const { data, loading } = useQuery(GetLayoutSetting);

  const leavePage = () => {
    goBack(paths.home);
  };

  const updateCustomerSettings = useUpdateCustomerSettings({
    onCompleted: leavePage,
  });
  if (loading) return null;

  const initialValues = {
    workBlockLayout: data?.customerSettings.workBlockLayout,
    workOrderCardLayout: data?.workOrderLayoutSetting,
  };

  const handleSave = (layoutSetting) => updateCustomerSettings(layoutSetting);

  return (
    <PageWithBreadcrumbs className="spec-customer-settings" data-testid="title" title="Layout">
      <Form initialValues={initialValues} onSave={handleSave}>
        <LayoutSetting />
        <StickyFooter>
          <FormButtons onCancel={leavePage} />
        </StickyFooter>
      </Form>
    </PageWithBreadcrumbs>
  );
}
